<template>
  <div :class="['org-tree-node', { 'org-tree-node--horizontal': horizontal }]">
    <div class="org-tree-row">
      <div :class="['org-card', 'org-card--' + nodeType]">
        <div class="org-card__header">
          <span class="org-card__icon"><i :class="typeIcon"></i></span>
          <span class="org-card__title">{{ node.title }}</span>
          <span v-if="hasChildren" class="org-card__badge">{{ childCount }}</span>
        </div>
        <div class="org-card__body">
          <span
            v-if="isClickable"
            class="org-card__name org-card__name--link"
            @click="$emit('navigate', node.id)"
          >{{ node.name }}</span>
          <span v-else class="org-card__name">{{ node.name }}</span>
        </div>
        <button
          v-if="hasChildren"
          class="org-card__toggle"
          @click="$emit('toggle', nodeKey)"
          :title="isCollapsed ? 'Expand' : 'Collapse'"
        >
          <span :class="['toggle-arrow', isCollapsed ? 'toggle-arrow--right' : 'toggle-arrow--down']"></span>
        </button>
      </div>
    </div>
    <div v-if="hasChildren && !isCollapsed" :class="['org-tree-children', { 'org-tree-children--horizontal': horizontal }]">
      <div
        v-for="child in node.children"
        :key="child.id + '_' + child.title"
        class="org-tree-child"
      >
        <div :class="['org-tree-connector', { 'org-tree-connector--horizontal': horizontal }]">
          <div class="connector-line"></div>
        </div>
        <org-node
          :node="child"
          :collapsed-map="collapsedMap"
          :horizontal="horizontal"
          @toggle="$emit('toggle', $event)"
          @navigate="$emit('navigate', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrgNode',
  props: {
    node: { type: Object, required: true },
    collapsedMap: { type: Object, required: true },
    horizontal: { type: Boolean, default: false },
  },
  computed: {
    nodeType() {
      const t = (this.node.title || '').toLowerCase();
      if (t === 'platform') return 'platform';
      if (t === 'organization') return 'organization';
      if (t.startsWith('branch')) return 'branch';
      if (t === 'admin') return 'admin';
      if (t === 'manager') return 'manager';
      if (t === 'agent') return 'agent';
      return 'default';
    },
    nodeKey() {
      return this.node.id + '_' + this.node.title;
    },
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    isCollapsed() {
      return !!this.collapsedMap[this.nodeKey];
    },
    isClickable() {
      return this.node.title === 'Admin' || this.node.title === 'Agent' || this.node.title === 'Manager';
    },
    childCount() {
      return this.node.children ? this.node.children.length : 0;
    },
    typeIcon() {
      const icons = {
        platform: 'fas fa-layer-group',
        organization: 'fas fa-building',
        branch: 'fas fa-code-branch',
        admin: 'fas fa-user-shield',
        manager: 'fas fa-user-tie',
        agent: 'fas fa-user',
      };
      return icons[this.nodeType] || 'fas fa-circle-notch';
    },
  },
};
</script>
